import { gql } from 'graphql-request'

const GET_GROUP_FILTERS = gql`
  query getFilters($slug: String) {
    type: products(
      where: {
        status: { _eq: "active" }
        product_group_connections: {
          product_group: { slug: { _ilike: $slug } }
        }
      }
      distinct_on: type
    ) {
      id: type
      name: type
    }

    product_categories(
      where: {
        products: {
          product: {
            status: { _eq: "active" }
            product_group_connections: {
              product_group: { slug: { _ilike: $slug } }
            }
          }
        }
      }
    ) {
      id
      name
    }

    creator_categories(
      where: {
        creators: {
          account_status: { _eq: "active" }
          products: {
            product_group_connections: {
              product_group: { slug: { _ilike: $slug } }
            }
          }
        }
      }
    ) {
      id
      name
    }
  }
`
export default GET_GROUP_FILTERS
